var _rect, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 447,
    viewBox: "0 0 1440 447",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1445,
    height: 445,
    transform: "translate(-5 1)",
    fill: "#BFCADF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_4762)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11_4762)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M668.125 77.395C276.372 178.94 162.631 38.295 52.7326 77.395C-113.844 136.965 -240.65 68.655 -240.65 68.655V0H1680.65V68.655C1680.65 68.655 1561.34 98.67 1498.32 102.35C1435.3 106.145 1377.66 88.205 1352.68 76.935C1307.92 57.04 1191.3 10.005 1094.46 5.405C997.628 0.805 705.398 67.85 668.125 77.395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M1169.58 77.395C1082.17 77.395 1021.26 50.715 921.545 32.43C866.595 22.425 632.773 20.815 433.534 77.395C234.295 133.975 257.351 37.835 146.876 77.395C-18.3555 136.045 -240.65 45.77 -240.65 45.77V0H1680.65V41.975C1680.65 41.975 1626.47 20.7 1503.7 20.7C1315.99 20.815 1249.7 77.395 1169.58 77.395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.26 33.235C846.998 -32.89 720.192 108.56 472.152 55.66C224.305 2.07 224.305 6.21 114.406 23.69C5.2765 41.17 13.5381 51.635 -67.925 60.375C-185.701 73.255 -240.65 0 -240.65 0H1680.65C1680.65 0 1661.63 47.035 1520.03 55.315C1378.43 63.595 1353.26 54.05 1231.26 33.235Z",
    fill: "#F8F8F8"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_11_4762)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_11_4762)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M771.875 379.7C1163.63 291.4 1277.37 413.7 1387.27 379.7C1553.84 327.9 1680.65 387.3 1680.65 387.3V447H-240.65V387.3C-240.65 387.3 -121.337 361.2 -58.3187 358C4.69995 354.7 62.3389 370.3 87.3158 380.1C132.082 397.4 248.705 438.3 345.538 442.3C442.372 446.3 734.602 388 771.875 379.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M270.416 379.7C357.835 379.7 418.74 402.9 518.455 418.8C573.405 427.5 807.227 428.9 1006.47 379.7C1205.7 330.5 1182.65 414.1 1293.12 379.7C1458.36 328.7 1680.65 407.2 1680.65 407.2V447H-240.65V410.5C-240.65 410.5 -186.469 429 -63.6985 429C124.013 428.9 190.297 379.7 270.416 379.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.742 418.1C593.002 475.6 719.808 352.6 967.848 398.6C1215.7 445.2 1215.7 441.6 1325.59 426.4C1434.72 411.2 1426.46 402.1 1507.93 394.5C1625.7 383.3 1680.65 447 1680.65 447H-240.65C-240.65 447 -221.629 406.1 -80.0295 398.9C61.5703 391.7 86.7394 400 208.742 418.1Z",
    fill: "#F8F8F8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_4762"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 115,
    fill: "white",
    transform: "translate(-240)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11_4762"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1921.3,
    height: 115,
    fill: "white",
    transform: "translate(-240.65)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_11_4762"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 100,
    fill: "white",
    transform: "matrix(-1 0 0 -1 1680 447)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_11_4762"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1921.3,
    height: 100,
    fill: "white",
    transform: "matrix(-1 0 0 -1 1680.65 447)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.9059d134a0267bb2e73cf6247c3ce176.svg";
export { ForwardRef as ReactComponent };